/* eslint-disable react/no-array-index-key */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { post, put } from '../../helpers/api_helper';
import TagSelector from '../Common/TagSelector';

function PropertyForm(props) {
  const {
    entity,
    t,
    onSuccess,
  } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const ValidationSchema = Yup.object().shape({
    label: Yup
      .string()
      .required(props.t(t('Label is required'))),
    tags: Yup.array().of(Yup.object().shape({
      id: Yup.number().required(),
    })),
    choices: Yup.array().of(Yup.string().required(t('Choice value is required'))),
  });

  const createProperty = async (data) => {
    try {
      const prop = await post('/api/fuse/property', data);

      toastr.success(`Property ${data.name} created!`, t('Success'));
      onSuccess(prop);
    } catch (error) {
      toastr.error(error.message, t('Error while creating'));
    }
  };

  const editProperty = async (data) => {
    try {
      const prop = await put(`/api/fuse/property/${data.id}`, data);

      toastr.success(`${data.label} updated!`, t('Success'));
      onSuccess(prop);
    } catch (error) {
      toastr.error(error.message, t('Error while updating'));
    }
  };

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={entity}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        if (!values.id) {
          createProperty(values);
        } else {
          editProperty(values);
        }
      }}
    >
      {({
        setFieldValue, values,
      }) => (
        <Form className="mt-3" id="FuseFamilyPropertyForm" autoComplete="off">
          <Row className="mt-3">
            <Col sm="6">
              <Label
                for="label"
              >
                {props.t('Property Label')}
                {' '}
                <sup className="text-danger">*</sup>
              </Label>
              <Field className="form-control" readOnly={values.id} name="label" />
              <ErrorMessage
                name="label"
                component="div"
                className="text-danger pt-2"
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col sm="8">
              <Label
                for="idk"
              >
                {props.t('Tags')}
                {' '}
                <sup className="text-danger">*</sup>
              </Label>
              <TagSelector
                id="FamilyTags"
                initialTags={entity.tags}
                onUpdate={(tags) => {
                  setFieldValue('tags', tags);
                }}
              />
              <div className="text-muted pt-1">
                {t('Describe the type of parts this applies to so we can filter later')}
                <br />
                <small>
                  Tags selected must
                  {' '}
                  <strong>ALL</strong>
                  {' '}
                  be present on the items. Only 1 tag is necessary.
                </small>
              </div>
            </Col>
          </Row>

          <hr className="border-bottom" />

          <Row>
            <Col xxl="4">
              <h5>{t('Choices')}</h5>

              <FieldArray name="choices">
                {({ push, remove, form }) => (
                  <div>
                    {form.values.choices && form.values.choices.length > 0 ? (
                      form.values.choices.map((choice, index) => (
                        <div key={index} className="d-flex align-items-center mb-2">
                          <Field
                            name={`choices[${index}]`}
                            className="form-control me-2"
                            placeholder={props.t('Enter choice')}
                          />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => remove(index)}
                          >
                            &times;
                          </button>
                        </div>
                      ))
                    ) : (
                      <div className="text-muted mb-2">{props.t('No choices yet.')}</div>
                    )}

                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => push('')}
                    >
                      <span className="mdi mdi-plus-thick" />
                      {' '}
                      {props.t('Add Choice')}
                    </button>
                  </div>
                )}
              </FieldArray>
            </Col>
          </Row>

          <hr className="border-bottom" />

          <Row className="mt-3">
            <Col sm="8">
              <Label
                for="instructions"
              >
                {props.t('Instructions')}
              </Label>
              <Field className="form-control" as="textarea" name="instructions" />
              <div className="text-muted mt-1">
                {t('Explain to anyone how to solve the choices of this property')}
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );

  return jsx;
}

PropertyForm.defaultProps = {
  entity: {
    label: '',
    tags: [],
    choices: [
      'Yes',
      'No',
    ],
  },
  onSuccess: () => {},
};

PropertyForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(PropertyForm));
